import { Route } from '@angular/router';
import { DC_ROUTING } from 'src/app/shared/routing.tokens';

export const authenticationRoutes: Route[] = [
    {
        path: DC_ROUTING.LOGIN,
        loadComponent: () => import('./pages/login/login.component').then((c) => c.LoginComponent),
    },
    {
        path: `${DC_ROUTING.VENUES}/${DC_ROUTING.LINK_LANE}`,
        loadComponent: () => import('./pages/venues/link-lane/link-lane.component').then((c) => c.LinkLaneComponent),
    },
    {
        path: DC_ROUTING.REGISTER,
        loadComponent: () => import('./pages/register/register.component').then((c) => c.RegisterComponent),
    },
    {
        path: DC_ROUTING.FORGOT_PASSWORD,
        loadComponent: () =>
            import('./pages/forgot-password/forgot-password.component').then((c) => c.ForgotPasswordComponent),
    },
];
